import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const CustomContentView: LoadableType<{
	spaceKey: string;
	contentId: string;
}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-srcCustomContentView" */ '../src/CustomContentView.tsx'
			)
		).CustomContentView,
});
